import { createRef, Component } from 'react'
import { node, string, number, instanceOf } from 'prop-types'
import { CSSTransition } from 'react-transition-group'

import CardHeader from './card-header.js'
import FeedSubImageContributorDetails from './feed-sub-image-contributor-details.js'
import Video from '../../theme-components/video.js'
import PostText from '../../theme-components/post-text.js'
import Icon from '../../../icon/index.js'
import PostImage from '../../theme-components/post-image.js'
import PostTypeIndicator from '../../theme-components/PostTypeIndicator.js'
import Settings from '../../../../../models/settings.js'
import Post from '../../../../../models/Post.js'

const DEFAULT_TRANSITION = {
  classNames: 'show-display-post',
  appear: true,
  timeout: 500,
  in: true,
  unmountOnExit: true,
}

export default class FeedPost extends Component {
  static propTypes = {
    feedKey: string.isRequired,
    post: instanceOf(Post).isRequired,
    settings: instanceOf(Settings).isRequired,
    socialCommerceButton: node.isRequired,
    socialCommercePosition: string.isRequired,
    width: number.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      paddingBottom: '100%',
    }

    this.nodeRef = createRef()
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextState.paddingBottom !== this.state.paddingBottom
  }

  onLoad = (image, paddingBottom) => {
    if (paddingBottom !== this.state.paddingBottom) {
      this.setState({
        paddingBottom,
      })
    }
  }

  render() {
    const { feedKey, post, socialCommercePosition, socialCommerceButton, settings, width } =
      this.props

    const { autoplayVideos, feedFontSize, gutterSize, isCenteredTheme, showPostText } = settings

    return (
      <div
        className="bzfy-c-cardflow-post"
        style={{
          backgroundColor: settings.postBackgroundColor,
          color: settings.postColor,
          marginBottom: gutterSize,
        }}
      >
        <CardHeader post={post} settings={settings} />
        <CSSTransition nodeRef={this.nodeRef} {...DEFAULT_TRANSITION}>
          <div ref={this.nodeRef} className="bzfy-c-cardflow-image-container">
            <div className="bzfy-c-cardflow-image-container__inner">
              {post.getIsVideoPost() && autoplayVideos ? (
                <Video
                  autoPlay={autoplayVideos}
                  mediaIndex={post.thumbnailMediaPosition}
                  post={post}
                  width={width}
                />
              ) : (
                <div
                  className="bzfy-c-cardflow-image"
                  style={{ paddingBottom: this.state.paddingBottom }}
                >
                  <PostImage
                    locale={settings.locale}
                    onLoad={this.onLoad}
                    post={post}
                    sizes={width}
                  />
                </div>
              )}
              <PostTypeIndicator autoplayEnabled={autoplayVideos} post={post} settings={settings} />
            </div>
            {socialCommercePosition === 'top' && !isCenteredTheme && socialCommerceButton}
          </div>
        </CSSTransition>
        <FeedSubImageContributorDetails feedKey={feedKey} post={post} settings={settings} />
        <div aria-hidden="true" className="bzfy-o-body" style={{ fontSize: feedFontSize }}>
          {showPostText && (
            <p className="bzfy-o-body__content">
              {settings.showPostText && (
                <PostText hashtagColor={settings.hashtagColor} postText={post.text} />
              )}
            </p>
          )}
          {socialCommercePosition === 'bottom' && <div>{socialCommerceButton}</div>}
          {settings.showPlatformIcon && (
            <div className="bzfy-o-social">
              <Icon color={settings.postColor} icon={`social-${post.sourceName}`} />
            </div>
          )}
        </div>
      </div>
    )
  }
}
